var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('y-panel',{staticClass:"form-title"},[_c('h5',{staticClass:"__title"},[_vm._v(" "+_vm._s(_vm.element.title)+" ")]),_c('p',{staticClass:"__desc mb0"},[_vm._v(" "+_vm._s(_vm.element.description)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }